export default __webpack_public_path__ + "static/media/shape3.ce1db5c1.png";